import React from 'react';
import { createRoot } from "react-dom/client";
import './index.css';
import App from './App';
// eslint-disable-next-line
import rollbar from "./rollbar/rollbar";
import * as serviceWorker from './serviceWorker';

const root = createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorker.unregister();
